"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

// Full-bleed hero image for a single blog post. Image only — the title / tags /
// date live in the rounded panel that overlaps this from below (BlogPostHeader),
// matching the Figma. A dim overlay + bottom fade-to-black blend it into the
// black content panel.
export default function BlogPostBanner({ image, alt }) {
  const t = useTranslations("blog.post");

  return (
    <div className="relative h-[360px] w-full sm:h-[460px] lg:h-[580px]">
      <Image
        src={image || "/images/banner_blog.webp"}
        alt={alt || t("coverAlt")}
        fill
        priority
        sizes="100vw"
        className="object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black to-transparent" />
      {/* Bottom-most left-fading strip (Figma) */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black to-black/0" />
    </div>
  );
}
